import { cva, type VariantProps } from 'class-variance-authority';

/** Card container: border, background, padding, and gap by size. All tokens from EDU Design System. */
export const valuePropVariants = cva(
  'rounded-md border border-neutral-200 bg-white',
  {
    variants: {
      size: {
        sm: 'px-xs py-xxs gap-xs',
        lg: 'px-md py-md gap-sm',
      },
    },
    defaultVariants: {
      size: 'lg',
    },
  },
);

/** Typography for the content area (right side). Matches size variant. */
export const valuePropChildrenVariants = cva('', {
  variants: {
    size: {
      sm: 'text-b4',
      lg: 'text-b3',
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});
